export const boardDailyReportTour = {
  key: "boardDailyReport",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-dailyreport-add"]',
      content: t("Tour_BoardDailyReport_Add"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-dailyreport-reminder"]',
      content: t("Tour_BoardDailyReport_Reminder"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-dailyreport-filter"]',
      content: t("Tour_BoardDailyReport_Filter"),
      placement: "top",
    },
    {
      target: '[data-tour="board-dailyreport-editor"]',
      content: t("Tour_BoardDailyReport_Table"),
      placement: "top",
    },
    {
      target: '[data-tour="board-dailyreport-export"]',
      content: t("Tour_BoardDailyReport_Export"),
      placement: "top",
    },
  ],
};
